import React from 'react'

const JobItemLod = () => {
    return (
        <div className='col-lg-3 mb-4'>

            <div className='job_item_box shadow rounded-3 h-100' style={{ backgroundColor: '#5E5E5E', color: 'white' }}>
                <div className='job_img' style={{ minHeight: "140px", backgroundColor: `#BDBDBD` }}>
                    
                </div>
                <h4 className='display-6 p-1 text-center' >
                
                </h4>
            </div>
        </div>
    )
}

export default JobItemLod